import { Component, Input, ViewChild } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { UserInterestsFormComponent } from '../../../shared/components/user/user-interests-form/user-interests-form.component';
import { AccountsService } from '../../../services/identity/accounts.service';

@Component({
    selector: 'app-onboarding-user-interests',
    templateUrl: './onboarding-user-interests.component.html',
    styleUrls: ['./onboarding-user-interests.component.scss'],
})
export class OnboardingUserInterestsComponent {
    public currentUser: User;
    @ViewChild(UserInterestsFormComponent) public userInterestsComponent: UserInterestsFormComponent;

    constructor(private readonly accountService: AccountsService) {
        this.currentUser = accountService.currentUser;
    }

    public save(): Promise<boolean> {
        return this.userInterestsComponent.save();
    }
}
